import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular'
import { NgxsModule } from '@ngxs/store'
import { environment } from '../environments/environment'
import { Environment } from '../environments/environment.interface'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { configureAmplify } from './auth/configure'
import { HierarchyMenuComponent } from './common/components/hierarch-menu/hierarchy-menu.component'
import { LoaderComponent } from './common/components/loader/loader.component'
import { MultiClientWarningComponent } from './common/components/multi-client-warning/multi-client-warning.component'
import { ToolbarComponent } from './common/components/toolbar/toolbar.component'
import { TokenInterceptor } from './common/interceptor/token.interceptor'
import { HighlightPipe } from './common/pipes/highlight.pipe'
import { TimekeeperService } from './common/services/time-keeper.service'
import { LoginComponent } from './login/login.component'
import { SharedModule } from './shared/shared.module'
import { AccountDialogComponent } from './ui/accounts/account-dialog/account-dialog.component'
import { AccountsComponent } from './ui/accounts/accounts/accounts.component'
import { ClientsAndProjectsComponent } from './ui/clients-and-projects/clients-and-projects.component'
import { ClientsDialogComponent } from './ui/clients-and-projects/clients-dialog/clients-dialog.component'
import { ProjectDialogComponent } from './ui/clients-and-projects/project-dialog/project-dialog.component'
import { DateSelectorComponent } from './ui/components/date-selector/date-selector.component'
import { ProfilePreferencesComponent } from './ui/components/navigation/profile-preferences/profile-preferences.component'
import { EmployeeFilterComponent } from './ui/employee-filter/employee-filter.component'
import { EmployeeDialogComponent } from './ui/employee/employee-dialog/employee-dialog.component'
import { EmployeeComponent } from './ui/employee/employee.component'
import { HomeLayoutComponent } from './ui/home-layout/home-layout.component'
import { NotAuthorizedComponent } from './ui/not-authorized/not-authorized.component'
import { ImportDialogComponent } from './ui/import/import-dialog/import-dialog/import-dialog.component'
import { LoginLayoutComponent } from './ui/login-layout/login-layout.component'
import { NavigationComponent } from './ui/navigation/navigation.component'
import { StartComponent } from './ui/start/start.component'
import { TimecardDialogComponent } from './ui/timecards/timecard-dialog/timecard-dialog.component'
import { TimecardsComponent } from './ui/timecards/timecards.component'
import { DayRepresentationRowComponent } from './ui/timesheets/day-representation-row/day-representation-row.component'
import { TimesheetsDetailComponent } from './ui/timesheets/timesheets-detail/timesheets-detail.component'
import { TimesheetsNotInvoiceDialogComponent } from './ui/timesheets/timesheets-not-invoice-dialog/timesheets-not-invoice-dialog.component'
import { TimesheetsResetDialogComponent } from './ui/timesheets/timesheets-reset-dialog/timesheets-reset-dialog.component'
import { TimesheetsTableComponent } from './ui/timesheets/timesheets-table/timesheets-table.component'
import { TimesheetsComponent } from './ui/timesheets/timesheets.component'
import { WhatsNewComponent } from './ui/whats-new/whats-new.component'

@NgModule({
    declarations: [
        AppComponent,
        StartComponent,
        ToolbarComponent,
        HierarchyMenuComponent,
        ToolbarComponent,
        AccountDialogComponent,
        LoaderComponent,
        NavigationComponent,
        AccountsComponent,
        WhatsNewComponent,
        LoginComponent,
        EmployeeComponent,
        EmployeeDialogComponent,
        TimesheetsComponent,
        DateSelectorComponent,
        TimecardsComponent,
        DateSelectorComponent,
        ClientsAndProjectsComponent,
        ClientsDialogComponent,
        LoginLayoutComponent,
        HomeLayoutComponent,
        NotAuthorizedComponent,
        ProjectDialogComponent,
        TimesheetsDetailComponent,
        DayRepresentationRowComponent,
        TimesheetsResetDialogComponent,
        TimesheetsNotInvoiceDialogComponent,
        EmployeeFilterComponent,
        TimecardDialogComponent,
        HighlightPipe,
        TimesheetsTableComponent,
        MultiClientWarningComponent,
        ProfilePreferencesComponent,
        ImportDialogComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        SharedModule,
        MatSelectModule,
        NgxsModule.forRoot(),
        AmplifyAuthenticatorModule,
        MatRadioModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'outline'
            } as MatFormFieldDefaultOptions
        },
        TimekeeperService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    awsCognito: Environment = environment
    constructor() {
        configureAmplify(this.awsCognito)
    }
}
